/* eslint-disable consistent-return */
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { ELEMENT_QUOTE, ELEMENT_QUOTE_AUTHOR, ELEMENT_QUOTE_CONTENT, QuotePluginOptions } from './QuotePlugin.types';

const QuoteElementReadOnly = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(() =>
    import(/* webpackExports: "QuoteElementReadOnly" */ './Element/QuoteElement').then(
      (mod) => mod.QuoteElementReadOnly
    )
  )
);
const QuoteElementAuthorReadOnly = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(() =>
    import(/* webpackExports: "QuoteElementAuthorReadOnly" */ './Element/QuoteElementAuthor').then(
      (mod) => mod.QuoteElementAuthorReadOnly
    )
  )
);
const QuoteElementContentReadOnly = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(() =>
    import(
      /* webpackExports: "QuoteElementContentReadOnly" */ './Element/QuoteElementContent'
    ).then((mod) => mod.QuoteElementContentReadOnly)
  )
);

export const QuoteReadOnlyPlugin = (options: QuotePluginOptions = {}): SlatePlugin => {
  return {
    renderElement: (renderProps: RenderElementProps) => {
      const { element } = renderProps;
      switch (element.type) {
        case ELEMENT_QUOTE: {
          return <QuoteElementReadOnly {...renderProps} {...options} />;
        }
        case ELEMENT_QUOTE_CONTENT: {
          return <QuoteElementContentReadOnly {...renderProps} {...options} />;
        }
        case ELEMENT_QUOTE_AUTHOR: {
          return <QuoteElementAuthorReadOnly {...renderProps} {...options} />;
        }
      }
    },
  };
};
